




import store from '@/store'

export default
  data: () ->
    customer_name: ''
  created: () ->
    @customer_name = await store.getters.customerName
